export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    return
  }
  if (from.query.referer_code && !to.query.referer_code) {
    return navigateTo({ name: to.name ?? 'index', query: { ...to.query, referer_code: from.query.referer_code } })
  }
})
